import React from 'react';

import { ApolloLink, ApolloClient, InMemoryCache } from 'apollo-boost';
import { createAppSyncLink } from 'aws-appsync';
import { createAuthLink } from 'aws-appsync-auth-link';
import { useQuery, ApolloProvider } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import { cognitoAuth, CognitoAuthProvider, useCognitoAuthContext } from '../contexts/CognitoAuthContext';

const getAccessToken = async () => {
  const token = cognitoAuth
    .getCachedSession()
    .getIdToken()
    .getJwtToken();
  return token;
};

const url = process.env.REACT_APP_GRAPHQL_URI as string;
const region = process.env.REACT_APP_AWS_REGION as string;
const authType = 'AMAZON_COGNITO_USER_POOLS';

const link = ApolloLink.from([
  createAuthLink({
    url,
    region,
    auth: { type: authType, jwtToken: getAccessToken },
  }),
  createAppSyncLink({
    url,
    region,
    auth: { type: authType, jwtToken: getAccessToken },
    // Don't know what this is for exactly but it is a required option.
    complexObjectsCredentials: () => null,
  }),
]);

const cache = new InMemoryCache({ addTypename: false });

const apolloClient = new ApolloClient({ link, cache });

type GetStatusResult = {
  user: {
    id: string;
    nickname: string;
    avatar: { url: string; uploadPngUrl: string; uploadJpgUrl: string };
  };
};

const useGetStatus = () =>
  useQuery<{ getStatus: GetStatusResult }>(gql`
    {
      getStatus {
        user {
          id
          nickname
          avatar {
            url
            uploadPngUrl
            uploadJpgUrl
          }
        }
      }
    }
  `);

const OldAccountName: React.FC = () => {
  const { data, loading } = useGetStatus();
  const user = data?.getStatus.user;
  if (loading) {
    return <div className="text-xl font-bold inline-block animate-spin">/</div>
  }
  return <>{user?.nickname}</>
};

const OldAccountContent: React.FC = () => {
  const cognito = useCognitoAuthContext();
  const { hash } = window.location;

  React.useEffect(() => {
    hash.includes('id_token') && cognito.instance.parseCognitoWebResponse(hash);
  }, [hash, cognito]);

  if (!cognito.instance.isUserSignedIn()) {
    return (
      <div className="flex flex-row justify-center">
        <button className="px-4 py-2 bg-sky-500 text-white text-lg font-bold rounded-lg cursor-pointer" onClick={() => cognito.instance.getSession()}>login to an old snapshot account</button>
      </div>
    );
  }

  return (
    <div className="p-4 flex flex-col gap-2">
      <div>logged into old account: <OldAccountName /></div>
      <div className="flex flex-row justify-center">
        <button className="px-4 py-2 bg-sky-500 text-white text-lg font-bold rounded-lg cursor-pointer" onClick={() => cognito.instance.signOut()}>logout of old account</button>
      </div>
    </div>
  );
};

export const OldAccount: React.FC =() => {
  return <div className="m-6 p-4 bg-white text-black rounded-lg">
    <h2 className="text-xl">Manage your old SnapshotVR account</h2>
    <div className="text-gray-500">from back in the olden days</div>
    <CognitoAuthProvider>
      <ApolloProvider client={apolloClient as any}>
        <OldAccountContent />
      </ApolloProvider>
    </CognitoAuthProvider>
  </div>
};
